import {ValidationType} from './ValidationType'

export const PropertiesValidation = {
  LeaseYears: {
    validationType: ValidationType.Numeric,
    isRequired: false,
    maxLength: 3,
    maxValue: 2147483647
  },
  ID: {
    validationType: ValidationType.TextFreeFormat,
    isRequired: false,
    maxLength: 0,
    maxValue: 0
  },
  Description: {
    validationType: ValidationType.TextFreeFormat,
    isRequired: false,
    maxLength: 300,
    maxValue: 0
  },
  FullDescription: {
    validationType: ValidationType.TextFreeFormat,
    isRequired: false,
    maxLength: 0,
    maxValue: 0
  },
  BulletPoints: {
    validationType: ValidationType.TextFreeFormat,
    isRequired: false,
    maxLength: 0,
    maxValue: 0
  },
  Notes: {
    validationType: ValidationType.TextFreeFormat,
    isRequired: false,
    maxLength: 0,
    maxValue: 0
  },
  ContactID: {
    validationType: ValidationType.Numeric,
    isRequired: true,
    maxLength: 10,
    maxValue: 2147483647
  },
  UserID: {
    validationType: ValidationType.Numeric,
    isRequired: true,
    maxLength: 10,
    maxValue: 2147483647
  },
  AssistedByUserID: {
    validationType: ValidationType.Numeric,
    isRequired: true,
    maxLength: 10,
    maxValue: 2147483647
  },
  SiteID: {
    validationType: ValidationType.Numeric,
    isRequired: false,
    maxLength: 10,
    maxValue: 2147483647
  },
  CompanyID: {
    validationType: ValidationType.Numeric,
    isRequired: true,
    maxLength: 10,
    maxValue: 2147483647
  },
  BlockManagementCompanyID: {
    validationType: ValidationType.Numeric,
    isRequired: false,
    maxLength: 10,
    maxValue: 2147483647
  },
  AltReference: {
    validationType: ValidationType.TextUpperLowerCase,
    isRequired: false,
    maxLength: 50,
    maxValue: 0
  },
  Status: {
    validationType: ValidationType.Numeric,
    isRequired: false,
    maxLength: 3,
    maxValue: 255
  },
  StatusDate: {
    validationType: ValidationType.DateTime,
    isRequired: true,
    maxLength: 0,
    maxValue: 0
  },
  Category: {
    validationType: ValidationType.Numeric,
    isRequired: false,
    maxLength: 3,
    maxValue: 255
  },
  Tenure: {
    validationType: ValidationType.Numeric,
    isRequired: false,
    maxLength: 3,
    maxValue: 255
  },
  Type: {
    validationType: ValidationType.Numeric,
    isRequired: true,
    maxLength: 3,
    maxValue: 255
  },
  SellingMethod: {
    validationType: ValidationType.Numeric,
    isRequired: false,
    maxLength: 3,
    maxValue: 255
  },
  DisplayAddress: {
    validationType: ValidationType.TextFreeFormat,
    isRequired: false,
    maxLength: 120,
    maxValue: 0
  },
  CountryCode: {
    validationType: ValidationType.Numeric,
    isRequired: false,
    maxLength: 10,
    maxValue: 2147483647
  },
  PropertyName: {
    validationType: ValidationType.TextUpperLowerCase,
    isRequired: false,
    maxLength: 50,
    maxValue: 0
  },
  Street: {
    validationType: ValidationType.TextUpperLowerCase,
    isRequired: false,
    maxLength: 50,
    maxValue: 0
  },
  Locality: {
    validationType: ValidationType.TextUpperLowerCase,
    isRequired: false,
    maxLength: 30,
    maxValue: 0
  },
  Town: {
    validationType: ValidationType.TextUpperLowerCase,
    isRequired: false,
    maxLength: 30,
    maxValue: 0
  },
  Region: {
    validationType: ValidationType.TextUpperLowerCase,
    isRequired: false,
    maxLength: 30,
    maxValue: 0
  },
  Postcode: {
    validationType: ValidationType.PostCode,
    isRequired: false,
    maxLength: 30,
    maxValue: 0
  },
  Country: {
    validationType: ValidationType.TextUpperLowerCase,
    isRequired: false,
    maxLength: 30,
    maxValue: 0
  },
  PropertyLocalAuthorityID: {
    validationType: ValidationType.Numeric,
    isRequired: true,
    maxLength: 10,
    maxValue: 2147483647
  },
  PropertyTaxBandID: {
    validationType: ValidationType.Numeric,
    isRequired: true,
    maxLength: 10,
    maxValue: 2147483647
  },
  PricePrefix: {
    validationType: ValidationType.Numeric,
    isRequired: false,
    maxLength: 3,
    maxValue: 255
  },
  Price: {
    validationType: ValidationType.Currency,
    isRequired: false,
    maxLength: 11,
    maxValue: 79228162514264337593543950335
  },
  PriceMatch: {
    validationType: ValidationType.Currency,
    isRequired: false,
    maxLength: 29,
    maxValue: 79228162514264337593543950335
  },
  PriceFrequency: {
    validationType: ValidationType.Numeric,
    isRequired: false,
    maxLength: 3,
    maxValue: 255
  },
  ValuationPrice: {
    validationType: ValidationType.Currency,
    isRequired: false,
    maxLength: 13,
    maxValue: 79228162514264337593543950335
  },
  PotentialAnnualRent: {
    validationType: ValidationType.Currency,
    isRequired: false,
    maxLength: 13,
    maxValue: 79228162514264337593543950335
  },
  Deposit: {
    validationType: ValidationType.Currency,
    isRequired: false,
    maxLength: 11,
    maxValue: 79228162514264337593543950335
  },
  CurrencyID: {
    validationType: ValidationType.Numeric,
    isRequired: false,
    maxLength: 10,
    maxValue: 2147483647
  },
  AddedDate: {
    validationType: ValidationType.DateTime,
    isRequired: true,
    maxLength: 0,
    maxValue: 0
  },
  UpdatedDateTime: {
    validationType: ValidationType.DateTime,
    isRequired: true,
    maxLength: 0,
    maxValue: 0
  },
  MarketDate: {
    validationType: ValidationType.DateTime,
    isRequired: true,
    maxLength: 0,
    maxValue: 0
  },
  ExpiryDate: {
    validationType: ValidationType.DateTime,
    isRequired: true,
    maxLength: 0,
    maxValue: 0
  },
  AgencyType: {
    validationType: ValidationType.Numeric,
    isRequired: false,
    maxLength: 3,
    maxValue: 255
  },
  IntroductionFee: {
    validationType: ValidationType.Currency,
    isRequired: false,
    maxLength: 13,
    maxValue: 79228162514264337593543950335
  },
  IntroductionPercentage: {
    validationType: ValidationType.Numeric,
    isRequired: false,
    maxLength: 3,
    maxValue: 100
  },
  CommissionFee: {
    validationType: ValidationType.Currency,
    isRequired: false,
    maxLength: 13,
    maxValue: 79228162514264337593543950335
  },
  CommissionPercentage: {
    validationType: ValidationType.Numeric,
    isRequired: false,
    maxLength: 3,
    maxValue: 100
  },
  PaymentCycleID: {
    validationType: ValidationType.Numeric,
    isRequired: true,
    maxLength: 10,
    maxValue: 2147483647
  },
  DetailsFileName: {
    validationType: ValidationType.TextFreeFormat,
    isRequired: false,
    maxLength: 0,
    maxValue: 0
  },
  PicturesHighRes: {
    validationType: ValidationType.TextFreeFormat,
    isRequired: false,
    maxLength: 0,
    maxValue: 0
  },
  Pictures: {
    validationType: ValidationType.TextFreeFormat,
    isRequired: false,
    maxLength: 0,
    maxValue: 0
  },
  PictureWebMain: {
    validationType: ValidationType.Numeric,
    isRequired: false,
    maxLength: 3,
    maxValue: 255
  },
  FloorPlanFileNameWeb: {
    validationType: ValidationType.FileName,
    isRequired: false,
    maxLength: 255,
    maxValue: 0
  },
  FloorPlanFileNamePrint: {
    validationType: ValidationType.FileName,
    isRequired: false,
    maxLength: 255,
    maxValue: 0
  },
  Directions: {
    validationType: ValidationType.TextFreeFormat,
    isRequired: false,
    maxLength: 0,
    maxValue: 0
  },
  Built: {
    validationType: ValidationType.Numeric,
    isRequired: false,
    maxLength: 4,
    maxValue: 32767
  },
  NewHome: {
    validationType: ValidationType.Numeric,
    isRequired: false,
    maxLength: 3,
    maxValue: 255
  },
  ExclusiveHome: {
    validationType: ValidationType.Numeric,
    isRequired: false,
    maxLength: 3,
    maxValue: 255
  },
  Age: {
    validationType: ValidationType.Numeric,
    isRequired: false,
    maxLength: 3,
    maxValue: 255
  },
  Bedrooms: {
    validationType: ValidationType.Numeric,
    isRequired: false,
    maxLength: 2,
    maxValue: 15
  },
  PermittedOccupiers: {
    validationType: ValidationType.Numeric,
    isRequired: false,
    maxLength: 2,
    maxValue: 255
  },
  Bathrooms: {
    validationType: ValidationType.Numeric,
    isRequired: false,
    maxLength: 2,
    maxValue: 255
  },
  ReceptionRooms: {
    validationType: ValidationType.Numeric,
    isRequired: false,
    maxLength: 2,
    maxValue: 255
  },
  Gardens: {
    validationType: ValidationType.Numeric,
    isRequired: false,
    maxLength: 3,
    maxValue: 255
  },
  Land: {
    validationType: ValidationType.Numeric,
    isRequired: false,
    maxLength: 3,
    maxValue: 255
  },
  Lift: {
    validationType: ValidationType.Numeric,
    isRequired: false,
    maxLength: 3,
    maxValue: 255
  },
  Garage: {
    validationType: ValidationType.Numeric,
    isRequired: false,
    maxLength: 3,
    maxValue: 255
  },
  ParkingOffStreet: {
    validationType: ValidationType.Numeric,
    isRequired: false,
    maxLength: 2,
    maxValue: 2147483647
  },
  DoubleGlazing: {
    validationType: ValidationType.Numeric,
    isRequired: false,
    maxLength: 3,
    maxValue: 255
  },
  CentralHeating: {
    validationType: ValidationType.Numeric,
    isRequired: false,
    maxLength: 3,
    maxValue: 255
  },
  OpenFireStove: {
    validationType: ValidationType.Numeric,
    isRequired: false,
    maxLength: 3,
    maxValue: 255
  },
  Gas: {
    validationType: ValidationType.Numeric,
    isRequired: false,
    maxLength: 3,
    maxValue: 255
  },
  Electric: {
    validationType: ValidationType.Numeric,
    isRequired: false,
    maxLength: 3,
    maxValue: 255
  },
  Water: {
    validationType: ValidationType.Numeric,
    isRequired: false,
    maxLength: 3,
    maxValue: 255
  },
  Drainage: {
    validationType: ValidationType.Numeric,
    isRequired: false,
    maxLength: 3,
    maxValue: 255
  },
  Telephone: {
    validationType: ValidationType.Numeric,
    isRequired: false,
    maxLength: 3,
    maxValue: 255
  },
  Cable: {
    validationType: ValidationType.Numeric,
    isRequired: false,
    maxLength: 3,
    maxValue: 255
  },
  OtherServices: {
    validationType: ValidationType.TextUpperLowerCase,
    isRequired: false,
    maxLength: 255,
    maxValue: 0
  },
  RentalAvailableDate: {
    validationType: ValidationType.DateTime,
    isRequired: false,
    maxLength: 0,
    maxValue: 0
  },
  RentalTerms: {
    validationType: ValidationType.Numeric,
    isRequired: false,
    maxLength: 3,
    maxValue: 255
  },
  RentalMinimumTerm: {
    validationType: ValidationType.Numeric,
    isRequired: false,
    maxLength: 10,
    maxValue: 2147483647
  },
  RentalBenefit: {
    validationType: ValidationType.Numeric,
    isRequired: false,
    maxLength: 3,
    maxValue: 255
  },
  RentalPets: {
    validationType: ValidationType.Numeric,
    isRequired: false,
    maxLength: 3,
    maxValue: 255
  },
  RentalIncludesBills: {
    validationType: ValidationType.Numeric,
    isRequired: false,
    maxLength: 3,
    maxValue: 255
  },
  RentalFurnished: {
    validationType: ValidationType.Numeric,
    isRequired: false,
    maxLength: 3,
    maxValue: 255
  },
  RentalChildren: {
    validationType: ValidationType.Numeric,
    isRequired: false,
    maxLength: 3,
    maxValue: 255
  },
  RentalStudents: {
    validationType: ValidationType.Numeric,
    isRequired: false,
    maxLength: 3,
    maxValue: 255
  },
  RentalHMO: {
    validationType: ValidationType.Numeric,
    isRequired: false,
    maxLength: 3,
    maxValue: 255
  },
  RentalSmokers: {
    validationType: ValidationType.Numeric,
    isRequired: false,
    maxLength: 3,
    maxValue: 255
  },
  RentalManagementType: {
    validationType: ValidationType.Numeric,
    isRequired: false,
    maxLength: 3,
    maxValue: 255
  },
  ManagementTypeID: {
    validationType: ValidationType.Numeric,
    isRequired: false,
    maxLength: 10,
    maxValue: 2147483647
  },
  ViewingArrangements: {
    validationType: ValidationType.Numeric,
    isRequired: true,
    maxLength: 10,
    maxValue: 2147483647
  },
  ViewingNotes: {
    validationType: ValidationType.TextFreeFormat,
    isRequired: false,
    maxLength: 0,
    maxValue: 0
  },
  PropertyAreaID: {
    validationType: ValidationType.Numeric,
    isRequired: true,
    maxLength: 10,
    maxValue: 2147483647
  },
  Board: {
    validationType: ValidationType.Numeric,
    isRequired: false,
    maxLength: 10,
    maxValue: 2147483647
  },
  UtilitySupplierGasID: {
    validationType: ValidationType.Contact,
    isRequired: false,
    maxLength: 10,
    maxValue: 2147483647
  },
  UtilitySupplierElectricityID: {
    validationType: ValidationType.Contact,
    isRequired: false,
    maxLength: 10,
    maxValue: 2147483647
  },
  UtilitySupplierWaterID: {
    validationType: ValidationType.Contact,
    isRequired: false,
    maxLength: 10,
    maxValue: 2147483647
  },
  UtilitySupplierTelephoneID: {
    validationType: ValidationType.Contact,
    isRequired: false,
    maxLength: 10,
    maxValue: 2147483647
  },
  UtilitySupplierCableID: {
    validationType: ValidationType.Contact,
    isRequired: false,
    maxLength: 10,
    maxValue: 2147483647
  },
  UtilitySupplierDrainageID: {
    validationType: ValidationType.Contact,
    isRequired: false,
    maxLength: 10,
    maxValue: 2147483647
  },
  UtilitySupplierGasRef: {
    validationType: ValidationType.TextUpperLowerCase,
    isRequired: false,
    maxLength: 50,
    maxValue: 0
  },
  UtilitySupplierElectricityRef: {
    validationType: ValidationType.TextUpperLowerCase,
    isRequired: false,
    maxLength: 50,
    maxValue: 0
  },
  UtilitySupplierWaterRef: {
    validationType: ValidationType.TextUpperLowerCase,
    isRequired: false,
    maxLength: 50,
    maxValue: 0
  },
  UtilitySupplierTelephoneRef: {
    validationType: ValidationType.TextUpperLowerCase,
    isRequired: false,
    maxLength: 50,
    maxValue: 0
  },
  UtilitySupplierCableRef: {
    validationType: ValidationType.TextUpperLowerCase,
    isRequired: false,
    maxLength: 50,
    maxValue: 0
  },
  UtilitySupplierDrainageRef: {
    validationType: ValidationType.TextUpperLowerCase,
    isRequired: false,
    maxLength: 50,
    maxValue: 0
  },
  ForceWebUpload: {
    validationType: ValidationType.Numeric,
    isRequired: false,
    maxLength: 3,
    maxValue: 255
  },
  SalesProgressorID: {
    validationType: ValidationType.Numeric,
    isRequired: true,
    maxLength: 10,
    maxValue: 2147483647
  },
  SolicitorID: {
    validationType: ValidationType.Contact,
    isRequired: false,
    maxLength: 10,
    maxValue: 2147483647
  },
  PropertyDevelopmentID: {
    validationType: ValidationType.Numeric,
    isRequired: false,
    maxLength: 10,
    maxValue: 2147483647
  },
  VirtualTourURL: {
    validationType: ValidationType.WebPage,
    isRequired: false,
    maxLength: 255,
    maxValue: 0
  },
  VirtualTourURL2: {
    validationType: ValidationType.WebPage,
    isRequired: false,
    maxLength: 255,
    maxValue: 0
  },
  AdvertDescription: {
    validationType: ValidationType.TextFreeFormat,
    isRequired: false,
    maxLength: 500,
    maxValue: 0
  },
  WebFeatured: {
    validationType: ValidationType.Numeric,
    isRequired: false,
    maxLength: 3,
    maxValue: 255
  },
  GroundRent: {
    validationType: ValidationType.Currency,
    isRequired: false,
    maxLength: 12,
    maxValue: 79228162514264337593543950335
  },
  GroundRentFrequency: {
    validationType: ValidationType.Numeric,
    isRequired: false,
    maxLength: 3,
    maxValue: 255
  },
  ServiceCharge: {
    validationType: ValidationType.Currency,
    isRequired: false,
    maxLength: 11,
    maxValue: 79228162514264337593543950335
  },
  ServiceChargeFrequency: {
    validationType: ValidationType.Numeric,
    isRequired: false,
    maxLength: 3,
    maxValue: 255
  },
  DisabledAccess: {
    validationType: ValidationType.Numeric,
    isRequired: false,
    maxLength: 3,
    maxValue: 255
  },
  Retirement: {
    validationType: ValidationType.Numeric,
    isRequired: false,
    maxLength: 3,
    maxValue: 255
  },
  DevelopmentPotential: {
    validationType: ValidationType.Numeric,
    isRequired: false,
    maxLength: 3,
    maxValue: 255
  },
  InvestmentPotential: {
    validationType: ValidationType.Numeric,
    isRequired: false,
    maxLength: 3,
    maxValue: 255
  },
  RequiresUpdating: {
    validationType: ValidationType.Numeric,
    isRequired: false,
    maxLength: 3,
    maxValue: 255
  },
  Riverside: {
    validationType: ValidationType.Numeric,
    isRequired: false,
    maxLength: 3,
    maxValue: 255
  },
  Seaside: {
    validationType: ValidationType.Numeric,
    isRequired: false,
    maxLength: 3,
    maxValue: 255
  },
  FirstTimeBuyersOnly: {
    validationType: ValidationType.Numeric,
    isRequired: false,
    maxLength: 3,
    maxValue: 255
  },
  LeisureFacilities: {
    validationType: ValidationType.Numeric,
    isRequired: false,
    maxLength: 3,
    maxValue: 255
  },
  LeaseExpiryDate: {
    validationType: ValidationType.DateTime,
    isRequired: false,
    maxLength: 0,
    maxValue: 0
  },
  FloorArea: {
    validationType: ValidationType.Numeric,
    isRequired: false,
    maxLength: 8,
    maxValue: 79228162514264337593543950335
  },
  LandArea: {
    validationType: ValidationType.Numeric,
    isRequired: false,
    maxLength: 8,
    maxValue: 79228162514264337593543950335
  },
  Floor: {
    validationType: ValidationType.Numeric,
    isRequired: false,
    maxLength: 3,
    maxValue: 255
  },
  SoldPrice: {
    validationType: ValidationType.Currency,
    isRequired: false,
    maxLength: 13,
    maxValue: 79228162514264337593543950335
  },
  MortgageAmount: {
    validationType: ValidationType.Currency,
    isRequired: false,
    maxLength: 13,
    maxValue: 79228162514264337593543950335
  },
  DepositAmount: {
    validationType: ValidationType.Currency,
    isRequired: false,
    maxLength: 13,
    maxValue: 79228162514264337593543950335
  },
  ManagingAgentID: {
    validationType: ValidationType.Contact,
    isRequired: false,
    maxLength: 10,
    maxValue: 2147483647
  },
  EPCNotRequired: {
    validationType: ValidationType.Numeric,
    isRequired: false,
    maxLength: 3,
    maxValue: 255
  },
  UploadPDF: {
    validationType: ValidationType.Numeric,
    isRequired: false,
    maxLength: 3,
    maxValue: 255
  },
  DisinstructionTypeID: {
    validationType: ValidationType.Numeric,
    isRequired: true,
    maxLength: 10,
    maxValue: 2147483647
  },
  Longitude: {
    validationType: ValidationType.NumericNeg,
    isRequired: false,
    maxLength: 29,
    maxValue: 79228162514264337593543950335
  },
  Latitude: {
    validationType: ValidationType.NumericNeg,
    isRequired: false,
    maxLength: 29,
    maxValue: 79228162514264337593543950335
  },
  MapZoomLevel: {
    validationType: ValidationType.Numeric,
    isRequired: false,
    maxLength: 3,
    maxValue: 255
  },
  SuppressStreetView: {
    validationType: ValidationType.Numeric,
    isRequired: false,
    maxLength: 3,
    maxValue: 255
  },
  StreetViewHeading: {
    validationType: ValidationType.Numeric,
    isRequired: false,
    maxLength: 10,
    maxValue: 2147483647
  },
  Qualification: {
    validationType: ValidationType.Numeric,
    isRequired: false,
    maxLength: 3,
    maxValue: 255
  },
  ShortCode: {
    validationType: ValidationType.Numeric,
    isRequired: false,
    maxLength: 10,
    maxValue: 2147483647
  },
  PropertyChainID: {
    validationType: ValidationType.Numeric,
    isRequired: false,
    maxLength: 10,
    maxValue: 2147483647
  },
  Float: {
    validationType: ValidationType.Currency,
    isRequired: false,
    maxLength: 13,
    maxValue: 79228162514264337593543950335
  },
  LonRes: {
    validationType: ValidationType.Numeric,
    isRequired: false,
    maxLength: 3,
    maxValue: 255
  },
  CommissionSplit: {
    validationType: ValidationType.Numeric,
    isRequired: false,
    maxLength: 3,
    maxValue: 100
  },
  UseClass: {
    validationType: ValidationType.Numeric,
    isRequired: false,
    maxLength: 3,
    maxValue: 255
  },
  ContactBankID: {
    validationType: ValidationType.Numeric,
    isRequired: false,
    maxLength: 10,
    maxValue: 2147483647
  },
  FloorAreaMin: {
    validationType: ValidationType.Numeric,
    isRequired: false,
    maxLength: 8,
    maxValue: 79228162514264337593543950335
  },
  Usage: {
    validationType: ValidationType.Numeric,
    isRequired: false,
    maxLength: 3,
    maxValue: 255
  },
  FloorAreaPrice: {
    validationType: ValidationType.Currency,
    isRequired: false,
    maxLength: 8,
    maxValue: 79228162514264337593543950335
  },
  PrimaryProperty: {
    validationType: ValidationType.Numeric,
    isRequired: false,
    maxLength: 3,
    maxValue: 255
  },
  LinkedTo: {
    validationType: ValidationType.PropertyLink,
    isRequired: false,
    maxLength: 10,
    maxValue: 2147483647
  },
  LettingFees: {
    validationType: ValidationType.TextUpperLowerCase,
    isRequired: false,
    maxLength: 4000,
    maxValue: 0
  },
  DetailsSent: {
    validationType: ValidationType.Numeric,
    isRequired: false,
    maxLength: 3,
    maxValue: 255
  },
  OccupierID: {
    validationType: ValidationType.Contact,
    isRequired: false,
    maxLength: 10,
    maxValue: 2147483647
  },
  GasPrePayment: {
    validationType: ValidationType.Numeric,
    isRequired: false,
    maxLength: 3,
    maxValue: 255
  },
  ElectricityPrePayment: {
    validationType: ValidationType.Numeric,
    isRequired: false,
    maxLength: 3,
    maxValue: 255
  },
  ElectricityEconomy7: {
    validationType: ValidationType.Numeric,
    isRequired: false,
    maxLength: 3,
    maxValue: 255
  },
  ProgressionManagedBy: {
    validationType: ValidationType.Numeric,
    isRequired: false,
    maxLength: 3,
    maxValue: 255
  },
  ViewingsManagedBy: {
    validationType: ValidationType.Numeric,
    isRequired: false,
    maxLength: 3,
    maxValue: 255
  },
  ClientLoginUpdated: {
    validationType: ValidationType.Numeric,
    isRequired: false,
    maxLength: 3,
    maxValue: 255
  },
  WebUploadSummary: {
    validationType: ValidationType.Numeric,
    isRequired: false,
    maxLength: 3,
    maxValue: 255
  },
  ApplicantMatchingType: {
    validationType: ValidationType.Numeric,
    isRequired: false,
    maxLength: 3,
    maxValue: 255
  },
  UploadPictures: {
    validationType: ValidationType.Numeric,
    isRequired: false,
    maxLength: 3,
    maxValue: 255
  },
  LocalPropertyTaxNumber: {
    validationType: ValidationType.TextFreeFormat,
    isRequired: false,
    maxLength: 30,
    maxValue: 0
  },
  UniqueReferenceNumber: {
    validationType: ValidationType.PropertyUniqueReferenceNumber,
    isRequired: false,
    maxLength: 30,
    maxValue: 0
  },
  What3Words: {
    validationType: ValidationType.TextFreeFormat,
    isRequired: false,
    maxLength: 100,
    maxValue: 0
  },
  CouncilTaxRate: {
    validationType: ValidationType.Currency,
    isRequired: false,
    maxLength: 29,
    maxValue: 79228162514264337593543950335
  },
  CouncilTaxRateExpiryDate: {
    validationType: ValidationType.DateTime,
    isRequired: false,
    maxLength: 0,
    maxValue: 0
  },
  SharedOwnershipPercentage: {
    validationType: ValidationType.Numeric,
    isRequired: false,
    maxLength: 3,
    maxValue: 255
  },
  SharedOwnershipRent: {
    validationType: ValidationType.Currency,
    isRequired: false,
    maxLength: 29,
    maxValue: 79228162514264337593543950335
  },
  SharedOwnershipFrequency: {
    validationType: ValidationType.Numeric,
    isRequired: false,
    maxLength: 3,
    maxValue: 255
  },
  ElectricMeterType: {
    validationType: ValidationType.Numeric,
    isRequired: false,
    maxLength: 3,
    maxValue: 255
  },
  ElectricDisabled: {
    validationType: ValidationType.Numeric,
    isRequired: false,
    maxLength: 3,
    maxValue: 255
  },
  GasMeterType: {
    validationType: ValidationType.Numeric,
    isRequired: false,
    maxLength: 3,
    maxValue: 255
  },
  GasDisabled: {
    validationType: ValidationType.Numeric,
    isRequired: false,
    maxLength: 3,
    maxValue: 255
  },
  WatermarkRequired: {
    validationType: ValidationType.Numeric,
    isRequired: false,
    maxLength: 3,
    maxValue: 255
  }
};
